import { logEvent } from 'firebase/analytics';
import { analytics } from '@/config/firebase';

function safe(fn: (a: NonNullable<typeof analytics>) => void): void {
  if (!analytics) return;
  try {
    fn(analytics);
  } catch (e) {
    if (import.meta.env.DEV) console.warn('[Analytics]', e);
  }
}

export const Analytics = {
  screenView(name: string): void {
    safe((a) => logEvent(a, 'screen_view', { firebase_screen: name, firebase_screen_class: name }));
  },

  login(provider: string): void {
    safe((a) => logEvent(a, 'login', { method: provider }));
  },

  logout(): void {
    safe((a) => logEvent(a, 'logout', {}));
  },

  postOpened(postId: number): void {
    safe((a) => logEvent(a, 'post_opened', { post_id: postId }));
  },

  postCreated(): void {
    safe((a) => logEvent(a, 'post_created', {}));
  },

  documentViewed(docId: number, title: string): void {
    safe((a) => logEvent(a, 'document_viewed', { document_id: docId, title }));
  },

  notificationTapped(notifId: number, type: string): void {
    safe((a) => logEvent(a, 'notification_tapped', { notification_id: notifId, type }));
  },

  dashboardDateChanged(range: string): void {
    safe((a) => logEvent(a, 'dashboard_date_changed', { range }));
  },
};
